import dayjs from "dayjs";
import { API_HOST, CONTACT_WA, HTTP_CODE, STORAGE_KEY } from "./Constant";

var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
};

export const Commons = {
    GetNoWa(dataLain, dataAyah, dataIbu, dataWali) {
        try {
            let waContact = dataLain["no_wa"];
            let data = dataAyah;
            if (waContact === CONTACT_WA.IBU) {
                data = dataIbu
            } else if (waContact === CONTACT_WA.WALI) {
                data = dataWali;
            }
            return data['no_hp']
        } catch (error) {
            console.log(error);
        }
        return "-";
    },
    GetUangDaftarUlang(jenjangTujuan, dataUangDaftarUlang) {
        try {
            let uangDaftarUlangs = dataUangDaftarUlang.split(';');
            for (let i = 0; i < uangDaftarUlangs.length; i++) {
                let uangDaftarUlang = uangDaftarUlangs[i].split('=');
                let keyUangDaftarUlang = uangDaftarUlang[0].toUpperCase();
                let valueUangDaftarUlang = uangDaftarUlang[1];
                if (keyUangDaftarUlang === jenjangTujuan) {
                    return valueUangDaftarUlang;
                }
            }
        } catch (error) {
            console.log(error);
        }
        return "-";
    },
    ShowTglLahir(tanggalLahir) {
        if (!tanggalLahir) {
            return "-"
        }
        return dayjs(tanggalLahir).format("DD/MM/YYYY")
    },
    IsAuth() {
        let authData = this.GetAuthDataInStorage("id");
        return (authData) ? true : false
    },
    IsAdmin() {
        let authData = this.GetAuthDataInStorage(STORAGE_KEY.AUTH_ADM);
        return (authData) ? true : false
    },
    SaveInStorage(newStorageData) {
        let currentStorageData = JSON.parse(localStorage.getItem(STORAGE_KEY.AUTH_DATA));
        if (currentStorageData) {
            newStorageData = { ...currentStorageData, ...newStorageData };
        }
        console.log(newStorageData);
        localStorage.setItem(STORAGE_KEY.AUTH_DATA, JSON.stringify(newStorageData));
    },
    RemoveAuthDataInStorage() {
        localStorage.removeItem(STORAGE_KEY.AUTH_DATA);
    },
    async GetAdditionalInformation(informationKey) {
        try {
            let currentStorageData = JSON.parse(localStorage.getItem(STORAGE_KEY.CONFIG_DATA));
            if (!currentStorageData || dayjs().isAfter(dayjs(currentStorageData[STORAGE_KEY.EXPIRY_DATA]))) {
                const responseTahunAjaranData = await this.GetData(API_HOST + "/items/tahun_ajarans", "filter[status]=Active&fields=kode,tahun_ajaran,id,wa_contact");
                const responseProgramData = await this.GetData(API_HOST + "/items/programs", "fields=id,nama_program,website_link,kelas_program.kelas,kelas_program.id", true);
                const kelasData = responseProgramData || [];
                const mergeData = { ...responseTahunAjaranData[0] || {}, "programs": kelasData };
                let configData = {
                    data: mergeData,
                    [STORAGE_KEY.EXPIRY_DATA]: dayjs().add(1, "day").toISOString()
                };
                localStorage.setItem(STORAGE_KEY.CONFIG_DATA, JSON.stringify(configData));
                currentStorageData = configData;
            }
            return currentStorageData.data[informationKey] || "";
        } catch (ex) {
            console.log(ex);
            return ""
        }
    },
    GetAuthDataInStorage(dataKey) {
        try {
            let currentStorageData = JSON.parse(localStorage.getItem(STORAGE_KEY.AUTH_DATA));
            return currentStorageData[dataKey];
        } catch (ex) {
            return ""
        }
    },
    GetDetailData(apiUrl, isNeedAuth = false) {
        let GetApiHeaders = JSON.parse(JSON.stringify(headers));
        if (isNeedAuth) {
            GetApiHeaders = this.SetAuthorizationHeader(GetApiHeaders);
        }
        return fetch(apiUrl,
            {
                method: "GET",
                headers: GetApiHeaders
            }
        ).then(this.ValidateResponse);
    },
    GetData(apiUrl, queryData = "", isNeedAuth = false) {
        var additionalUrl = "";
        if (queryData && queryData.trim()) {
            additionalUrl = "?" + queryData;
        }
        if (additionalUrl) {
            additionalUrl = additionalUrl + "&sort=date_updated";
        } else {
            additionalUrl = "?sort=-date_updated";
        }
        let GetApiHeaders = JSON.parse(JSON.stringify(headers));
        if (isNeedAuth) {
            GetApiHeaders = this.SetAuthorizationHeader(GetApiHeaders);
        }
        return fetch(apiUrl + additionalUrl,
            {
                method: "GET",
                headers: GetApiHeaders
            }
        ).then(this.ValidateResponse);
    },
    PostData(apiUrl, postData, isNeedAuth = false) {
        let GetApiHeaders = JSON.parse(JSON.stringify(headers));
        if (isNeedAuth) {
            GetApiHeaders = this.SetAuthorizationHeader(GetApiHeaders);
        }
        return fetch(
            apiUrl,
            {
                method: "POST",
                headers: GetApiHeaders,
                body: JSON.stringify(postData)
            }
        ).then(this.ValidateResponse);
    },
    UpdateData(apiUrl, postData, isNeedAuth = false) {
        let GetApiHeaders = JSON.parse(JSON.stringify(headers));
        if (isNeedAuth) {
            GetApiHeaders = this.SetAuthorizationHeader(GetApiHeaders);
        }
        return fetch(
            apiUrl,
            {
                method: "PATCH",
                headers: GetApiHeaders,
                body: JSON.stringify(postData)
            }
        ).then(this.ValidateResponse);
    },
    DeleteData(apiUrl, isNeedAuth = false) {
        let GetApiHeaders = JSON.parse(JSON.stringify(headers));
        if (isNeedAuth) {
            GetApiHeaders = this.SetAuthorizationHeader(GetApiHeaders);
        }
        return fetch(
            apiUrl,
            {
                method: "DELETE",
                headers: GetApiHeaders
            }
        ).then(this.ValidateResponse);
    },
    UploadFile(apiUrl, postData, isNeedAuth = false) {
        let uploadHeaders = {};
        if (isNeedAuth) {
            uploadHeaders = this.SetAuthorizationHeader(uploadHeaders);
        }
        return fetch(
            apiUrl,
            {
                method: "POST",
                body: postData,
                headers: uploadHeaders
            }
        ).then(this.ValidateResponse);
    },
    ValidateResponse(res) {
        if (!res.ok) {
            if (res.status === HTTP_CODE.ERR_NOT_AUTH || res.status === HTTP_CODE.ERR_FORBIDDEN) {
                // Check if already redirecting to prevent loop
                const currentPath = window.location.pathname;

                // Only redirect if not already on login page
                if (currentPath !== "/" && currentPath !== "/login") {
                    // Clear auth data before redirect
                    Commons.RemoveAuthDataInStorage();

                    // Use replace instead of href to prevent back button issues
                    window.location.replace("/?session=expired");
                }

                // Return rejected promise instead of redirecting immediately
                return Promise.reject({
                    error: "Authentication failed",
                    status: res.status
                });
            }
            
            // ✅ Handle non-JSON error responses
            return res.text().then(text => {
                try {
                    const json = JSON.parse(text);
                    return Promise.reject(json);
                } catch (e) {
                    return Promise.reject({
                        error: "Server Error",
                        message: text || `HTTP ${res.status}: ${res.statusText}`,
                        status: res.status
                    });
                }
            });
        }
        
        // ✅ Check Content-Type before parsing JSON
        const contentType = res.headers.get("content-type");
        
        // Handle empty responses (204 No Content, etc.)
        if (res.status === 204 || !contentType) {
            if(res.url.includes('alamat')){
                console.log("log in alamat");
                return res.json();
            }
            console.log("Empty response (204 or no content-type)");
            return Promise.resolve(null);
        }
        
        // Handle non-JSON responses
        if (!contentType || !contentType.includes("application/json")) {
            console.warn("Non-JSON response received:", contentType);
            return res.text().then(text => {
                console.log("Response text:", text);
                return Promise.reject({
                    error: "Invalid Response Type",
                    message: "Expected JSON but received: " + contentType,
                    responseText: text
                });
            });
        }
        
        // ✅ Parse JSON with error handling
        return res.text()
            .then(text => {
                // Handle empty response body
                if (!text || text.trim() === '') {
                    console.warn("Empty response body");
                    return null;
                }
                
                try {
                    const response = JSON.parse(text);
                    
                    // Directus typically wraps data in { data: ... }
                    if (response && typeof response === 'object') {
                        // Check for Directus format
                        if ('data' in response) {
                            return response.data;
                        }

                        // Direct response
                        return response;
                    }

                    // Handle null/undefined responses
                    if (response === null || response === undefined) {
                        console.warn("Null response received");
                        return null;
                    }

                    // Return primitive values as-is (strings, numbers, booleans)
                    return response;
                    
                } catch (parseError) {
                    console.error("JSON Parse Error:", parseError);
                    console.error("Response text:", text);
                    return Promise.reject({
                        error: "Invalid JSON",
                        message: "Server returned invalid JSON response",
                        originalError: parseError.message,
                        responseText: text.substring(0, 200) // First 200 chars for debugging
                    });
                }
            })
            .catch(error => {
                // Handle text() method errors
                if (error.message && error.message.includes("text()")) {
                    console.error("Failed to read response body:", error);
                    return Promise.reject({
                        error: "Response Read Error",
                        message: "Failed to read response body",
                        originalError: error.message
                    });
                }
                
                // Re-throw other errors
                console.error("Response Processing Error:", error);
                return Promise.reject(error);
            });
    },
    ValidateDataSubmit(datas) {
        var newDatas = {};
        for (var data in datas) {
            let dataObj = datas[data];
            if (dataObj === null || (typeof dataObj === 'object' && Object.keys(dataObj).length === 0)) {
                continue;
            }
            newDatas[data] = datas[data];
        }
        return newDatas;
    },
    SetAuthorizationHeader(headers) {
        let returned_auth_object = this.GetAuthDataInStorage(STORAGE_KEY.AUTH_ADM) || this.GetAuthDataInStorage("id");
        headers["Authorization"] = "Bearer " + returned_auth_object;
        return headers;
    },
    RenderTemplate(html, data) {
        if (!html) {
            return "";
        }
        return html.replace(/{{(.*?)}}/g, (_, key) => {
            return data[key.trim()] ?? '';
        });
    }

}